export default __webpack_public_path__ + "static/media/CCO.c8c054d5.png";